import { API_BASE_URL } from '../../../lib/api';

import { apiFetch } from '@/lib/apiFetch';
import { withTenant } from '../../../lib/tenantHeaders';

const JSON_HEADERS = withTenant({ 'Content-Type': 'application/json' });

export const fetchAirports = async ({ limit = 10, offset = 1, query = {}, sort } = {}) => {
  const res = await apiFetch(`${API_BASE_URL}/airports/filter`, {
    method: 'POST',
    headers: JSON_HEADERS,
    body: JSON.stringify({ limit, offset, query, sort }),
  });
  return res.json();
};

export const createAirport = async (data) => {
  const res = await apiFetch(`${API_BASE_URL}/airports`, {
    method: 'POST',
    headers: JSON_HEADERS,
    body: JSON.stringify(data),
  });
  return res.json();
};

export const updateAirport = async (id, data) => {
  const res = await apiFetch(`${API_BASE_URL}/airports/${id}`, {
    method: 'PUT',
    headers: JSON_HEADERS,
    body: JSON.stringify(data),
  });
  return res.json();
};

export const deleteAirport = async (id) => {
  const res = await apiFetch(`${API_BASE_URL}/airports/${id}`, {
    method: 'DELETE',
    headers: withTenant(),
  });
  return res.json();
};

export const toggleAirportStatus = async (id) => {
  const res = await apiFetch(`${API_BASE_URL}/airports/${id}/toggle-status`, {
    method: 'POST',
    headers: JSON_HEADERS,
  });
  return res.json();
};

export const importAirports = async (rows) => {
  const res = await apiFetch(`${API_BASE_URL}/airports/import`, {
    method: 'POST',
    headers: JSON_HEADERS,
    body: JSON.stringify({ rows }),
  });
  return res.json();
};

export const exportAirports = async ({ query = {}, sort } = {}) => {
  return fetchAirports({ limit: 10000, offset: 1, query, sort });
};
